import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  GET_CONTRACT_RENEWAL_DETAILS_FAILED,
  GET_CONTRACT_RENEWAL_DETAILS_PENDING,
  GET_CONTRACT_RENEWAL_DETAILS_FULFILLED,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"

export const pendingAC = (type) => ({
  type,
})

export const failedAC = (type) => ({
  type,
})

export const fulfilledAC = (type, data) => ({
  type,
  payload: data,
})

export const getContractRenewalDetails =
  (customerId) => (dispatch, getState) => {
    dispatch(pendingAC(GET_CONTRACT_RENEWAL_DETAILS_PENDING))

    const api = `CONTRACT_RENEWAL_DETAILS`
    const apiKey = get(urls, `apiKey.USER.CONTRACT_RENEWAL_DETAILS`, ``)

    const template = URITemplate(urls.url[api])
    const state = getState()
    const locale = get(state, `siteLanguage.language`, ``)

    const url = template.expand({
      userId: get(state, `userAccount.userDetails.userId`, ``),
      lang: locale,
      customerId,
    })

    return getTokenAction(dispatch, getState).then((token) => {
      const config = {
        headers: {
          apiKey,
          oktaToken: token.accessToken,
        },
      }

      return axios
        .create(config)
        .get(url)
        .then((response) => {
          const data = get(response, `data.data`, {})
          dispatch(fulfilledAC(GET_CONTRACT_RENEWAL_DETAILS_FULFILLED, data))
          return data
        })
        .catch(() => {
          dispatch(failedAC(GET_CONTRACT_RENEWAL_DETAILS_FAILED))
        })
    })
  }
